export enum ProfileStepCode {
  MembershipCheck = 'membershipCheck',
  ResidenceQuestions = 'residenceQuestions',
  HealthQuestions = 'healthQuestions',
  MyRate = 'myRate',
  MyProfile = 'myProfile',
  MyProfileSteps = 'myProfileSteps',
  MyProfileStepSummary = 'myProfileStepSummary',
  MyContracts = 'myContracts',
  MyPremierRangMyBeneficiaries = 'myBeneficiaries', // CIMS specific
  MyBeneficiaries = 'myBeneficiaries',
  MyBeneficiariesContract = 'myBeneficiariesContract', // CIMS specific
  MyBeneficiariesNominative = 'myBeneficiariesNominative',
  MyBeneficiariesLibre = 'myBeneficiariesLibre',
  MyDetails = 'myDetails',
  MyContacts = 'myContacts',
  MyFinancial = 'myFinancial',
  MyBankDetails = 'myBankDetails',
  Signature = 'signature',
  PhoneConfirmation = 'phoneConfirmation',
  Finish = 'finish'
}
